// extracted by mini-css-extract-plugin
module.exports = {"root":"Tags_root__3L5i2","tag":"Tags_tag__FZ0T1","tagCloseButton":"Tags_tagCloseButton__3lpc7","fullWidth":"Tags_fullWidth__Zy3uS","limitHeight":"Tags_limitHeight__NafkU"};